export const skills = [
    {
        skill: 'Typescript',
        percentage: 94,
    },
    {
        skill: 'Javascript',
        percentage: 96,
    },
    {
        skill: 'Node.js',
        percentage: 88,
    },
    {
        skill: 'Express',
        percentage: 88,
    },
    {
        skill: 'AWS',
        percentage: 80,
    },
    {
        skill: 'SQL',
        percentage: 90,
    },
    {
        skill: 'React',
        percentage: 91,
    },
    {
        skill: 'Next.js',
        percentage: 86,
    },
    {
        skill: 'Qwik',
        percentage: 88,
    },
    {
        skill: 'TailwindCSS',
        percentage: 90,
    },
]
